/**
 * Get the gallery list from API
 * @param {object} state - The vuex state object
 * @return {object[]} A array of gallery list
 */
export const getGalleryList = (state) => {
  return Array.isArray(state.galleryList) ? state.galleryList : null
};
